import React from "react";
import {observer} from "mobx-react";
import {useStores} from "../../Hooks";
import GeneralDialog from "./GeneralDialog";
import {SelectFusionContent} from "./SelectFusionDialog";

const SelectSitePrepFusionFilesModal = observer(() => {
    const {modalStore, generalStore} = useStores();

    const isAddNew = !!modalStore.modalData.isAddNew;

    const addFilesAndGoToNext = () => {
        modalStore.isSelectSitePrepFusionFilesModalOpen = false;
        modalStore.isEditSitePrepChecklistModalOpen = true;
    }

    const onConfirm = async () => {
        if (isAddNew) {
            addFilesAndGoToNext();
        } else {
            await modalStore.modalData.updateSitePrep();
            modalStore.isSelectSitePrepFusionFilesModalOpen = false;
        }
    }

    return (
        <GeneralDialog
            openControl='isSelectSitePrepFusionFilesModalOpen'
            className={'procedure-option-dialog site-prep-options'}
            title={generalStore.translate('selectDigitalTwin')}
            body={<SelectFusionContent isSitePrepTemplate/>}
            noCancel={true}
            isConfirmDisabled={false}
            confirmText={generalStore.translate(isAddNew ? 'next' : 'save')}
            onConfirm={onConfirm}
            extraClose
            goBackControl={isAddNew ? 'isSetSitePrepNameModalOpen' : ''}
        />
    );
});

export default SelectSitePrepFusionFilesModal;